import Vue from 'vue'
import store from 'store'
import qs from 'qs'

export default {
    createTheme(rootState, newThemeName, callbacks)	{
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: 'La création du thème «' + newThemeName + '» a échoué.',
                type: 'danger'
            });
        };

        let params = qs.stringify({"data": JSON.stringify({
            "name": newThemeName
        })});
        Vue.axios.post(rootState.baseUrl + "/admin/theme/create", params, {"headers": rootState.postHeaders}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.id);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    linkReal(rootState, themeId, email, callbacks)	{
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: 'Le linkage a échoué.',
                type: 'danger'
            });
        };

        let params = qs.stringify({"data": JSON.stringify({
            "themeId": themeId,
            "email" : email
        })});
        Vue.axios.post(rootState.baseUrl + "/admin/real/add/theme", params, {"headers": rootState.postHeaders}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.user);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    unlinkReal(rootState, themeId, userId, callbacks)	{
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: 'Le linkage a échoué.',
                type: 'danger'
            });
        };

        let params = qs.stringify({"data": JSON.stringify({
            "themeId": themeId,
            "userId" : userId
        })});
        Vue.axios.post(rootState.baseUrl + "/admin/real/del/theme", params, {"headers": rootState.postHeaders}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.user);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    updateTheme(rootState, updatedThemeId, newName, callbacks) {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: 'La mise à jour du thème a échoué.',
                type: 'danger'
            });
        };

        let params = qs.stringify({"data": JSON.stringify({
            "name": newName
        })});
        Vue.axios.post(rootState.baseUrl + "/admin/theme/update/" + updatedThemeId, params, {"headers": rootState.postHeaders}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.id);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    deleteTheme(rootState, themeToDelete, callbacks)    {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: 'La suppression du thème «' + themeToDelete.name + '» a échoué.',
                type: 'danger'
            });
        };

        Vue.axios.delete(rootState.baseUrl + "/admin/theme/delete/" + themeToDelete.id, {"headers": rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success();
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    getThemeList(rootState, page, callbacks)  {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: 'La récupération de la liste des thèmes a échoué.',
                type: 'danger'
            });
        };
        Vue.axios.get(rootState.baseUrl + "/admin/themes/" + page, {headers: rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    getTheme(rootState, themeId, callbacks)  {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: 'La récupération du thème a échoué.',
                type: 'danger'
            });
        };

        Vue.axios.get(rootState.baseUrl + "/admin/theme/" + themeId, {headers: rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.theme);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    }
};